import { css, cx } from '@emotion/css';
import { useReactFlow } from '@xyflow/react';

import { Node } from '../types';
import { useIsInteractive } from './useIsInteractive';

const styles = {
  default: css({
    cursor: 'default',
  }),
  clickable: css({
    // specifically don't do :hover which would override other cursor styles
    cursor: 'pointer',
  }),
  move: css({
    cursor: 'move',
  }),
};

export function useCursorStyles(id: string) {
  const { getNode } = useReactFlow();
  const { isInteractive } = useIsInteractive();

  const node = getNode(id) as Node;
  const dragging = !!node?.dragging;
  const selected = !!node?.selected;
  const isClickable = !isInteractive && node.selectable !== false;
  const showMove = isInteractive && (selected || dragging);

  const cursorClassName = cx(
    styles.default,
    // View mode: pointer on clickable tiles.
    isClickable && styles.clickable,
    // Edit mode: default on hover; move when selected (one or many) or dragging.
    showMove && styles.move
  );

  return { isInteractive, dragging, cursorClassName, styles };
}
